<template>
  <div>
    <div class="main" >
      <div class="nav">
        <img @click="$router.go(-1)" style="width: 24px;height: 22px;margin-right:5px;" src="../../assets/image/back.png" alt="">
        <p style="font-family: PingFang-SC-Regular;font-size: 18px;font-weight: normal;font-stretch: normal;letter-spacing: 0px;color: #000000;">参数设置</p>
      </div>
      <div class="scroll">
        <div class="cont">
          <!-- 本机设置 -->
          <div class="box1">
            <div class="title">
              <div class="dian"></div>
              <p>本机设置</p>
            </div>
            <div class="items">
              <div class="row">
                <div class="item">
                   <p>服务器IP地址:</p>
                  <input v-model="datas.deviceSettingBean.serverAddress"  type="text" placeholder="请输入IP地址">
                </div>
                <div class="item">
                  <p>本机卡号:</p>
                  <input v-model="datas.deviceSettingBean.cardNumber" type="text" placeholder="请输入卡号">
                </div>
                <div class="item">
                  <p>左右笼选择:</p>
                  <el-select v-model="datas.deviceSettingBean.cageType" placeholder="请选择">
                    <el-option
                      v-for="item in options1"
                      :key="item.index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="item">
                  <p>前后门设置:</p>
                  <el-select v-model="datas.deviceSettingBean.doorType" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <div class="item">
                  <p>相似度识别:</p>
                  <input v-model="datas.deviceSettingBean.defaultSimilar"  type="text" placeholder="请输入数值">
                </div>
                <div class="item item-xxx">
                  <p>数据请求频率:</p>
                  <input v-model="datas.deviceSettingBean.frequency" type="text" placeholder="请输入时间">
                </div>
                <div class="item">
                  <p>启动人脸识别:</p>
                  <button  style="margin-right:40%"
                    :class="datas.deviceSettingBean.openFace?'btn-i':'blue'"
                    @click="openFace"
                    >{{datas.deviceSettingBean.openFace?'关闭':'开启'}}</button>
                </div>
                <div class="item">
                  <p>摄像头方向:</p>
                  <button 
                    :class="datas.deviceSettingBean.cameraType?'btn-i':'blue'" style="margin-right:40%"
                    @click="cameraType"
                    >{{datas.deviceSettingBean.cameraType?'关闭':'开启'}}</button>
                </div>
              </div>
              <div class="row" style="justify-content: center;">
                <div class="btn-i" style="width: 100px;" @click="Reset1">
                  重置
                </div>
                <div style="width: 60px;"></div>
                <div class="blue" style="width: 100px;" @click="upload">
                  确定
                </div>
              </div>
            </div>
          </div>
          <div class="box">
            <!-- 高度设置 -->
          <div class="box2">
            <div class="title">
              <div class="dian"></div>
              <p>高度设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i">
                <p>传感器最低数值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightSensorDown" type="text" placeholder="请输入数值">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i">
                <p>传感器最高处数值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightSensorUp" type="text" placeholder="请输入数值">
                  <div class="unit"></div>
                </div>
                
              </div>
              <div class="row-i">
                <p>设置总楼层数：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.floorNum" type="text" placeholder="请输入楼层数">
                  <!-- <div class="blue">获取</div> -->
                  <div style="font-size:16px;margin-right:19px">/层</div>
                </div>
              </div>
              <div class="row-i">
                <p>每层楼高度：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightEachFloor" type="text" placeholder="请输入高度">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>高度预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>速度预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.speedEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/m/s</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i"@click="Reset2">重置</button>
                <button class="blue" @click="upload">确定</button>
              </div>
            </div>
          </div>
           <!-- 倾角设置 -->
          <div class="box7">
            <div class="title">
              <div class="dian"></div>
              <p>倾角设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-aa">
                <p>传感器实时数据：</p>
                <div class="row-i-r">
                  <div
                    style="width: 188px;
                          height: 26px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          font-size: 12px;
                          line-height: 26px;
                          text-align: start;
                          color: #858585;"
                    ><input v-model="datas.tiltSettingBean.tiltX" class="jiaodu"  type="text">X
                      <input v-model="datas.tiltSettingBean.tiltY" class="jiaodu"  type="text">Y
                    </div>
                  <div></div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>倾角预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.tiltSettingBean.tiltEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>倾角报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.tiltSettingBean.tiltWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset3">重置</button>
                <button class="blue" @click="upload">确定</button>
              </div>
            </div>
          </div>
          <!-- 重量设置 -->
          <div class="box5">
            <div class="title">
              <div class="dian"></div>
              <p>重量设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-c">
                <p>传感器空载数值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightNoLoadSensor" type="text" placeholder="请输入数值">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>传感器负载数值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightLoadSensor" type="text" placeholder="请输入数值">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
                
              </div>
              <div class="row-i row-c">
                <p>负载重量：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightLoad" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>负荷：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightLoadValue" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>重量预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>重量报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset4">重置</button>
                <button class="blue" @click="upload">确定</button>
              </div>
            </div>
          </div>
          <!-- 风速设置 -->
          <!-- <div class="box6">
            <div class="title">
              <div class="dian"></div>
              <p>风速设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-dd row-d">
                <p>风速预警值：</p>
                <div class="row-i-r">
                  <div class="menu">
                    <div class="menu-title" @click="show(1)"><p>{{datas.windSpeedSettingBean.windSpeedEarlyWarning?datas.windSpeedSettingBean.windSpeedEarlyWarning:'请选择数据'}}</p><i></i></div>
                    <div class="menu-content" v-if="isShow.a">
                      <div class="m-c-t">安全风值：</div>
                      <div class="m-c-t-b"><p>风速</p><p>风级</p></div>
                      <div class="m-c-item" @click="fenji(0)"><p>0.2-2</p><p>0</p></div>
                      <div class="m-c-item" @click="fenji(1)"><p>0.3-1.5</p><p>1</p></div>
                      <div class="m-c-item" @click="fenji(2)"><p>1.6-3.3</p><p>2</p></div>
                      <div class="m-c-item" @click="fenji(3)"><p>3.4-5.4</p><p>3</p></div>
                      <div class="m-c-item" @click="fenji(4)"><p>5.5-7.9</p><p>4</p></div>
                      <div class="m-c-t">预警风值：</div>
                      <div class="m-c-t-b"><p>风速</p><p>风级</p></div>
                      <div class="m-c-item" @click="fenji(5)"><p>8.0-10.8</p><p>5</p></div>
                      <div class="m-c-item" @click="fenji(6)"><p>10.8-13.8</p><p>6</p></div>
                    </div>
                  </div>
                  <div class="unit">m/s</div>
                </div>
              </div>
              <div class="row-i row-d">
                <p>风速报警值：</p>
                <div class="row-i-r">
                  <div class="menu">
                    <div class="menu-title" @click="show(2)"><p>{{datas.windSpeedSettingBean.windSpeedWarning?datas.windSpeedSettingBean.windSpeedWarning:'请选择数据'}}</p><i></i></div>
                    <div class="menu-content menu-content-b " v-if="isShow.b">
                      <div class="m-c-t">危险风值：</div>
                      <div class="m-c-t-b"><p>风速</p><p>风级</p></div>
                      <div class="m-c-item" @click="fenji1(7)"><p>13.9-17.1</p><p>7</p></div>
                      <div class="m-c-item" @click="fenji1(8)"><p>17.2-20.7</p><p>8</p></div>
                      <div class="m-c-item" @click="fenji1(9)"><p>20.8-24.4</p><p>9</p></div>
                      <div class="m-c-item" @click="fenji1(10)"><p>24.5-28.4</p><p>10</p></div>
                      <div class="m-c-item" @click="fenji1(11)"><p>28.5-32.6</p><p>11</p></div>
                      <div class="m-c-item" @click="fenji1(12)"><p>32.7-36.9</p><p>12</p></div>
                    </div>
                  </div>
                  <div class="unit">m/s</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset6">重置</button>
                <button class="blue" @click="uploadDatas">确定</button>
              </div>
            </div>
          </div> -->
          </div>
          <el-dialog
            class="chongzhi"
            title="提示"
            :visible.sync="isShow.dialogVisible"
            width="30%">
            <span v-if="reset===5">是否确认上传数据</span>
            <span v-else>是否重置该模块数据</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isShow.dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="Resetss">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { error } from 'highcharts'
import myHttp from '../../../src/untils/port'
  export default {
    data() {
      return {
        isShow:{
          dialogVisible:false
        },
        datas:{
            deviceSettingBean:{
              cageType: '',
              cameraType: null,
              cardNumber: '',
              defaultSimilar: '',
              doorType: '',
              frequency: '',
              openFace: null,
              serverAddress: '',
            },
            heightSettingBean:{
              floorNum: '',
              heightCoefficientValue: '',
              heightEachFloor: '',
              heightEarlyWarning: '',
              heightFloorTotal: '',
              heightSensorDown: '',
              heightSensorUp: '',
              speedEarlyWarning: ''
            },
            tiltSettingBean:{
              tiltEarlyWarning: '',
              tiltWarning: '',
              tiltX: '',
              tiltY: '',
            },
            weightSettingBean:{
              weightCoefficientValue: '',
              weightEarlyWarning: '',
              weightLoad: '',
              weightLoadSensor: '',
              weightLoadValue: '',
              weightNoLoadSensor: '',
              weightWarning: '',
            }
          },
        options:[
          {
            value:'0',
            label:'前门'
          },
          {
            value:'1',
            label:'后门'
          }
        ],
        options1:[
          {
            value:'0',
            label:'左'
          },
          {
            value:'1',
            label:'右'
          }
        ],
        value:'',
        reset:0
      }
    },
    mounted(){
      this.getBasic()
      console.log(this.$route.query.id)
      // this.a()
    },
    methods:{
      // a(){
      //   if(this.datas.deviceSettingBean.doorType==0){
      //     this.value1='开'
      //   }
      //   if(this.datas.deviceSettingBean.doorType==1){
      //     this.value1='关'
      //   }
      //   if(this.datas.deviceSettingBean.cageType==0){
      //     this.value='左'
      //   }
      //   if(this.datas.deviceSettingBean.cageType==1){
      //     this.value='右'
      //   }
      // },
      upload(){
        this.isShow.dialogVisible = true
        this.reset=5
      },
      openFace(){
        this.datas.deviceSettingBean.openFace=!this.datas.deviceSettingBean.openFace
        let data1 = JSON.stringify(this.datas)
        console.log(this.datas,'999999999999999')
        let sj = this.sj()
        let _this = this
        myHttp.uploadElevatorSettings({
          "imei": `${_this.$route.query.id}`,
          // "imei":'ts2022031060123',
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
          if(res.data.code === 200){
            if(_this.datas.deviceSettingBean.openFace){
              _this.$message({
                message: '人脸识别已开启',
                type: 'success'
              })
            }else{
              _this.$message({
                message: '人脸识别已关闭',
                type: 'warning'
              })
            }
          }
        }).catch(error=>{
          _this.$message({
                message: '操作失败',
                type: 'error'
              })
          _this.datas.deviceSettingBean.openFace=!_this.datas.deviceSettingBean.openFace
        })
      },
      cameraType(){
        //==========================
         this.datas.deviceSettingBean.cameraType=!this.datas.deviceSettingBean.cameraType
          let data1 = JSON.stringify(this.datas)
          console.log(this.datas,'999999999999999')
          let sj = this.sj()
          let _this = this
          myHttp.uploadElevatorSettings({
            "imei": `${_this.$route.query.id}`,
            // "imei":'ts2022031060123',
            "settings": `${data1}`,
            "setDate": `${sj}`
          }).then(res=>{
            if(res.data.code === 200){
              if(_this.datas.deviceSettingBean.openFace){
                _this.$message({
                  message: '摄像头方向已开启',
                  type: 'success'
                })
              }else{
                _this.$message({
                  message: '摄像头方向已关闭',
            type: 'warning'
                })
              }
            }
          }).catch(error=>{
            _this.$message({
                  message: '操作失败',
                  type: 'error'
                })
            _this.datas.deviceSettingBean.cameraType=!_this.datas.deviceSettingBean.cameraType
          })
      },
      // 确定基础信息
      uploadElevatorSettings(){
        let data1 = JSON.stringify(this.datas)
        let sj = this.sj()
        let _this = this
        myHttp.uploadElevatorSettings({
          "imei": `${_this.$route.query.id}`,
          // "imei":'ts2022031060123',
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
          console.log(res,888)
        })
      },
      // 获取升降机配置
      getBasic(){
        let _this = this
        myHttp.getElevatorSettings({
          "imei": `${_this.$route.query.id}`
          // "imei":'ts2022031060123'
        }).then(res=>{
          console.log(res,'88888888888888')
          if(res.data.data.settings!==null){
          _this.datas = JSON.parse(res.data.data.settings)
          _this.datas.deviceSettingBean.cageType=_this.datas.deviceSettingBean.cageType+''
          _this.datas.deviceSettingBean.doorType=_this.datas.deviceSettingBean.doorType+''
          }
        }).catch(res=>{
          console.log(res)
        })
      },
      sj(){
        function formatDateTime(date){
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          var d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          var h = date.getHours()
          var minute = date.getMinutes()
          var miao = date.getSeconds()
          minute = minute < 10 ? ('0' + minute) : minute
          return y + '-' + m + '-' + d+' '+h+':'+minute+':'+miao
        }
        let date = formatDateTime(new Date())
        return date
      },
      Resetss(){
        if(this.reset===1){
          this.datas.deviceSettingBean.cageType='',
          this.datas.deviceSettingBean.cardNumber='',
          this.datas.deviceSettingBean.defaultSimilar='',
          this.datas.deviceSettingBean.doorType='',
          this.datas.deviceSettingBean.frequency='',
          this.datas.deviceSettingBean.serverAddress='',
          this.value1=''
          this.value=''
          this.isShow.dialogVisible = false
          this.reset=0
        }else if(this.reset===2){
          this.datas.heightSettingBean.floorNum= '',
          // this.heightSettingBean.heightCoefficientValue= '',
          this.datas.heightSettingBean.heightEachFloor='',
          this.datas.heightSettingBean.heightEarlyWarning='',
          // this.heightSettingBean.heightFloorTotal='',
          this.datas.heightSettingBean.heightSensorDown= '',
          this.datas.heightSettingBean.heightSensorUp= '',
          this.datas.heightSettingBean.speedEarlyWarning= ''
          this.isShow.dialogVisible = false
          this.reset=0
        }else if(this.reset===3){
          this.datas.tiltSettingBean.tiltEarlyWarning=''
          this.datas.tiltSettingBean.tiltWarning=''
          this.datas.tiltSettingBean.tiltX=''
          this.datas.tiltSettingBean.tiltY=''
          this.isShow.dialogVisible = false
          this.reset=0
        }else if(this.reset===4){
          // this.weightSettingBean.weightCoefficientValue="0.5769"
          this.datas.weightSettingBean.weightEarlyWarning=''
          this.datas.weightSettingBean.weightLoad=''
          this.datas.weightSettingBean.weightLoadSensor=''
          this.datas.weightSettingBean.weightLoadValue=''
          this.datas.weightSettingBean.weightNoLoadSensor=''
          this.datas.weightSettingBean.weightWarning=''
          this.isShow.dialogVisible = false
          this.reset=0
        }else if(this.reset===5){
          // console.log(this.datas.deviceSettingBean.cageType,this.datas.deviceSettingBean.doorType)
          let data1 = JSON.stringify(this.datas)
        let sj = this.sj()
        let _this = this
        myHttp.uploadElevatorSettings({
          "imei": `${_this.$route.query.id}`,
          // "imei":'ts2022031060123',
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
            if(res.data.code === 200){
              _this.$message({
                  message: '数据上传成功',
                  type: 'success'
                })
            }else{
                _this.$message({
                  message: '上传失败',
                  type: 'warning'
                })
              }
          }).catch(error=>{
            _this.$message({
                  message: '网络连接失败',
                  type: 'error'
                })
          })
          this.isShow.dialogVisible = false
          this.reset=0
        }
      },
      Reset1(){
        this.isShow.dialogVisible = true
        this.reset=1
      },
      Reset2(){
        this.isShow.dialogVisible = true
        this.reset=2
      },
      Reset3(){
        this.isShow.dialogVisible = true
        this.reset=3
      },
      Reset4(){
        this.isShow.dialogVisible = true
        this.reset=4
      }
    }
  }
</script>

<style scoped>
.main{
  background-color: #ECF0F5;
  height: 90.7vh;
  padding-left: 0.417vw;
  padding-right: 1.25vw;
}
.nav{
  display: flex;
  align-items: center;
  min-height: 4.525vh;
}
.scroll{
  height: 84.8vh;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.cont{
  min-width: 1656px;
  background-color: #ffffff;
  padding: 1vh 0.729vw;
  height: 100%;
}
.box1{
  height: 15.385vh;
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  padding-top: 0.905vh;
}
.dian{
  width: 0.754vh;
	height: 0.754vh;
	background-color: #0b62f0;
  border-radius: 50%;
  margin-right: 0.417vw;
  margin-left: 0.729vw;
}
.title{
  display: flex;
  align-items: center;
  margin-bottom: 0.452vh;
}
.items{
  padding: 0 1.615vw;
}
.row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.961vh;
  margin-bottom: 2vh;
}
.item{
  display: flex;
  justify-content: space-between;
  width: 16.239vw;
}
.item>p{
  font-family: PingFang-SC-Bold;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item>input{
  background-color: #f5f6fa;
	border-radius: 4px;
  width: 9.792vw;
  border: solid 0.5px #EAEAEA;
  padding-left: 10px;
  padding-top: 0.452vh;
  padding-bottom: 0.452vh;
  font-size: 12px;
}
.item>input:focus {
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
      outline: none; 
}
.item-xxx{
  position: relative;
}
.item-xxx::after{
content: "/min";
position: absolute;
right: 5px;bottom: 25%;
font-size: 12px;
}
.btn1{
  border: none;
  width: 3.13vw;
	height: 1.35vw;
	background-color: #3f9eff;
	border-radius: 0.21vw;
  color: #fff;
  font-size: 14px;
  margin-right: 40%;
}
.btn2{
  width: 3.13vw;
	height: 1.35vw;
	background-color: #fff;
	border-radius: 0.21vw;
  font-size: 14px;
  margin-right: 40%;
  border-radius: 4px;
	border: solid 1px #bbbbbb;
}
.btn3{
  border: none;
  width: 62px;
	height: 26px;
	background-color: #3f9eff;
	border-radius: 0.3vh;
  font-size: 14px;
  color: #fff;
}
.input-i{
  font-size: 12px;
  background-color: #f5f6fa;
	border-radius: 4px;
  border: solid 0.5px #EAEAEA;
  padding-left: 6px;
  padding-top: 0.452vh;
  padding-bottom: 0.452vh;
  width: 50%;
  margin-right: 3px;
}
.input-i:focus {
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
      outline: none; 
}
.item-r{
  display: flex;
  justify-content: end;
}
.box{
  min-width: 1649px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.box2, .box3, .box4, .box5, .box6, .box7, .box8, .box9, .box10{
  width: 544px;
	height: 298px;
  background-color: #ffffff;
	box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  margin-top: 1vh;
  padding: 14px 0px 9px 0px;
}
.text{
  margin-left: 2px;
  color: #666666;
}
.cont-i{
  height: 235px;
  position: relative;
}
.row-i{
  display: flex;
  justify-content: space-between;
  margin-left: 32px;
  margin-right: 14px;
}
.row-i>p{
  font-family: PingFang-SC-Bold;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 30px;
	letter-spacing: 0px;
	color: #333333;
}
.row-i>.row-i-r>input{
  width: 188px;
  height: 26px;
  font-size: 12px;
  background-color: #f5f6fa;
	border-radius: 4px;
  border: solid 0.5px #EAEAEA;
  padding-left: 6px;
}
.row-i>.row-i-r>input:focus {
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
      outline: none; 
}
.row-i-r{
  width: 328px;
  display: flex;
  justify-content: space-between;
}
.blue{
  border: none;
  width: 60px;
	height: 26px;
	background-color: #3f9eff;
	border-radius: 4px;
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #fefefe;
  line-height: 26px;
}
.blue:hover, .btn1:hover, .btn3:hover{
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 60%),
  0 2px 4px 0 rgba(232, 237, 250, 50%);
  background-color: #7bbdff;
  cursor: pointer;
}
.btn2:hover, .btn-i:hover{
  cursor: pointer;
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
.unit{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 26px;
	letter-spacing: 0px;
	color: #333333;
  margin-right: 20px;
}
.btn-i{
  width: 60px;
	height: 26px;
	background-color: #fff;
	border-radius: 0.21vw;
  font-size: 14px;
  border-radius: 4px;
	border: solid 1px #bbbbbb;
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 26px;
	letter-spacing: 0px;
	color: #333333;
}
.cont-i-b{
  position: absolute;
  left: 201px;
  bottom: -10px;
  width: 136px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.row-a{
  margin-bottom: 26px;
}
.row-aa{
  margin-bottom: 26px;
  padding-top: 36px;
}
.row-c{
  padding: 2px 0;
}
.menu-title{
  width: 188px;
  height: 26px;
  background-color: #f5f6fa;
  border-radius: 4px;
  border: solid 0.5px #EAEAEA;
  padding-left: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.menu-title>p{
  font-size: 12px;
  line-height: 26px;
  text-align: start;
  color:#858585;
}
.menu-title>i{
  margin-top:5px;
  margin-right: 20px;
  width: 0px;
    height: 0px;
    border: 6px solid transparent;
    border-top-color: #858585;
}
.row-dd{
  padding-top:45px ;
}
.row-d{
  padding-bottom:20px ;
}
.menu-content{
  position: absolute;
  left: 0;
  bottom: -251px;
  width: 188px;
	height: 255px;
  z-index: 20;
  background-color: #fff;
}
.m-c-t{
  background-color: #f9fafc;
  line-height: 30px;
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  text-align: start;
  padding: 0 20px;
}
.m-c-t-b>p, .m-c-item>p{
  font-family: PingFang-SC-Medium;
	font-size: 12px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  padding: 2.5px 20px;
}
.m-c-t-b, .m-c-item{
  display: flex;
  justify-content: space-between;
}
.m-c-item:hover{
  background-color: #eee;
}
.menu-content-b{
  height: 195px;
  bottom: -190px;
}
.row-aaa{
  padding: 88px 0;
}
.text-i{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.text-ii{
  width: 100px;
  display: flex;
  justify-content: space-between;
}
.text-ii>p{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.btnn{
  width: 110px;
}
.bb{
  width: 190px;
  left:114px;
}
.content-s{
  display: flex;
  width: 152px;
  justify-content: space-between;
}
.content-s>.item-s{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
  line-height: 30px;
	color: #333333;
}
.jiaodu{
  width: 30px;
    height: 26px;
    font-size: 12px;
    background-color: #f5f6fa;
    border-radius: 4px;
    border: solid 0.5px #EAEAEA;
    padding-left: 6px
}

.jiaodu:focus{
  box-shadow: 1.9px 2.3px 10px 0px rgb(105 159 204 / 50%);
    outline: none;
}
::v-deep .el-dialog{
  margin-top: 30vh !important;
}
::v-deep .chongzhi>.el-dialog{
  width: 21% !important;
}
::v-deep .el-input__inner{
  width: 9.792vw;
      height: 29px;
    line-height: 29px;
}
</style>